'use client';

// Libraries
import dynamic from 'next/dynamic';

// Constants
import { LAYOUT, PAGE } from '@/constants/config';

// Components
import Loading from '@/components/Loading';

// Variables
const TopContent = dynamic(
  () => import('@/components/ScanCCCDPassport/TopContent'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
const Partners = dynamic(() => import('@/components/Home/Partners'), {
  ssr: false,
  loading: () => <Loading />,
});
const ContactUs = dynamic(() => import('@/components/ContactUs'), {
  ssr: false,
  loading: () => <Loading />,
});

export default function ScanCCCDPassport() {
  return (
    <article className="help-portal">
      <TopContent />
      <Partners />
      <ContactUs />
    </article>
  );
}

ScanCCCDPassport.layout = LAYOUT.HEADER_NORMAL;
ScanCCCDPassport.canonical =
  [process.env.hostName, PAGE.SCAN_CCCD_PASSPORT].join('/') + '/';
ScanCCCDPassport.title = 'common.meta.page.scan-cccd-passport';
ScanCCCDPassport.image = '/assets/img/scan-cccd-passport/og-img.png';
ScanCCCDPassport.description =
  'content.scan-cccd-passport.top-content.description';
ScanCCCDPassport.imageWidth = 600;
ScanCCCDPassport.imageHeight = 426;
